import {getData, postData} from "../../common/api/api";

export class PasswordPolicyManager {
    constructor() {
        this.url = WebpackConfig.links.passwordData;
        this.requestTypes = {
            GET_FEEDBACK: 1
        };

        this.policyNotesDiv = document.querySelector('.policy-notes-div');
        if (this.policyNotesDiv) {
            this.listDiv = this.policyNotesDiv.querySelector('.policy-notes-list');
            this.loadingDiv = this.policyNotesDiv.querySelector('.loading-container');
            this.policyNamePrefixSpan = this.policyNotesDiv.querySelector('.policy-name-prefix');
            this.noteTitle = document.querySelector('.note-title');

            if (this.noteTitle) {
                this.noteTitle.style.display = 'none';
            }
            if (this.loadingDiv) {
                this.loadingDiv.style.display = 'none';
            }
        }
        this.resetPasswordToken = null;
    }

    toggleLoading(show) {
        if (!this.loadingDiv) return;
        this.loadingDiv.style.display = show ? 'block' : 'none';
    }

    loadFeedback(proposedPassword, policyId, loginId, callback) {
        const url = this.getEndpointUrl(this.requestTypes.GET_FEEDBACK, policyId, loginId);

        this.toggleLoading(true);

        postData(url, (result) => {
            this.toggleLoading(false);
            if (callback !== undefined) {
                callback(result);
            }

            if (result.status !== 200) {
                console.error(result);
                this.noteTitle.style.display = 'block';
                if (this.noteTitle) {
                    this.noteTitle.innerText = i18n.common.somethingWentWrong;
                }
                return;
            } else if (result.data instanceof Array) {
                this.noteTitle.style.display = 'block';
                this.addItemsToPolicyNotesList(result.data);
            }

            if (this.noteTitle) {
                this.noteTitle.style.display = this.hasItems() ? 'block' : 'none';
            }
        }, {}, {
            proposedPassword: proposedPassword
        });
    }

    getEndpointUrl(type, policyId, loginId) {
        let url = `${this.url}?type=${type}`;
        if (policyId !== undefined) {
            url += `&policyId=${policyId}`;
        }
        if (loginId !== undefined) {
            url += `&loginId=${loginId}`;
        }
        if (this.resetPasswordToken) {
            url += `&resetPasswordToken=${this.resetPasswordToken}`;
        }
        return url;
    }

    addItemsToPolicyNotesList(items) {
        this.clearPolicyNotesList();
        for (let i = 0; i < items.length; i++) {
            this.listDiv.appendChild(
                this.createPolicyListItem(items[i], items[i].includes(i18n.logins.met))
            );
        }
    }

    hasItems() {
        return this.listDiv.children.length > 0;
    }

    clearPolicyNotesList() {
        while (this.listDiv.firstChild) {
            this.listDiv.removeChild(this.listDiv.lastChild);
        }
    }

    addPasswordMatchesListItem(isMatch) {
        const matchMsg = `${i18n.logins.met} ${i18n.logins.passwordsMatch}`;
        const doesNotMatchMsg = `${i18n.logins.notMet} ${i18n.logins.passwordsDoNotMatch}`;

        this.removeFromPolicyNotesList(matchMsg);
        this.removeFromPolicyNotesList(doesNotMatchMsg);
        this.listDiv.appendChild(this.createPolicyListItem(
            isMatch ? matchMsg : doesNotMatchMsg, isMatch
        ));
    }

    removeFromPolicyNotesList(message) {
        for(let child = this.listDiv.firstChild; child !== null; child = child.nextSibling) {
            if (child.textContent === message) {
                this.listDiv.removeChild(child);
                break;
            }
        }
    }

    createPolicyListItem(message, meetsReq) {
        const li = document.createElement('li');
        if (meetsReq) {
            li.classList.add('meets-requirement');
        } else {
            li.classList.add('does-not-meet-requirement');
        }
        li.innerText = message;
        return li;
    }
}